<style lang="less" scoped>
  .template-item {
        position: relative;
        margin: 10px 0;
        border: grey dashed 1px;
        padding: 5px;
        border-radius: 10px;
        .upload_file {
            display: flex;
        }
        .close-icon {
          position: absolute;
          left: -9px;
          top: -12px;
          z-index: 1000;
        }
    }
</style>
<style lang="less">
    .upload_class {
    }
      .legel_audit_title {
        margin: 10px;
        line-height: 20px;
        font-size: 16px;
        color: #17233d;
        font-weight: 500;
        text-align: center;
      }
</style>
<template>
  <div>
    <Modal
      v-model="showModal"
      class="upload_class"
      :closable="false"
      :mask-closable="false"
      title="合同模板下载"
      width="800"
    >
      <Spin
        v-if="getLoading"
        size="large"
        fix
      />
      <p class="legel_audit_title">
        {{ name }}
      </p>
      <FileDownCom :files="list" />
      <template v-slot:footer>
        <i-button
          type="primary"
          @click.native="closeModal"
        >
          关闭
        </i-button>
      </template>
    </Modal>
  </div>
</template>
<script>
  import { KEY_NAME } from './constants'
  import { getConfigApi } from './editorServicer'
  import FileDownCom from './../../components/file/attachments'
    export default {
      components:{ FileDownCom } ,
        props: {
          value: {
            type: Boolean,
            default:() => false
          },
        },
        data (){
            return {
                // 上传地址
                showModal: this.value,
                getLoading: false,
                name:'',
                list:[]
            }
        },
        watch: { 
             value (val) {
               this.showModal = val;
               if(val) {
                 this.getLoading = true
                 getConfigApi.call(this,{ key_name: KEY_NAME },() => {
                  this.closeModal()
                  this.getLoading = false
                 }).then(data => {
                   this.name = data.name
                   this.list = data.content.map(item => {
                     item.file.desc = item.desc
                     item.file.account = '编辑日期'
                     return item.file
                   })
                   this.getLoading = false
                 })
               }
             }
        },
        methods: {
          closeModal () {
            this.$emit('closeModal',false)
          },
        },
    }
</script>
